export default __webpack_public_path__ + "static/media/HDPredictor.f9b8dffa.PNG";